define(['app'], function (app) {
  return app.Backbone.Model.extend({
    defaults: {
      type: false,
      msg: false
    }
  })
})
